<template>
  <g
    id="Left_Indicator_Light"
    v-on:click="changeSeverity('leftIndicatorLight')"
    :class="severityClass"
  >
    <path
      class="cls-40"
      d="M423.49,108.03c0,2.94,1.81,5.33,1.81,5.33,0,0,1.47-1.33,1.47-5.33,0-4.2-1.47-5.33-1.47-5.33,0,0-1.81,2.38-1.81,5.33Z"
    />
    <path
      class="cls-881"
      d="M416.2,106.25c1.61-1.55,4.56-3.55,9.09-3.55v10.65c-4.53,0-7.48-2-9.09-3.55-1.02-.98-1.02-2.58,0-3.56Z"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
